import { Injectable } from "@angular/core";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { forkJoin, Observable, of } from "rxjs";
import { concatMap, map, switchMap } from "rxjs/operators";
import { GlobalFunction } from "../globalFuntion";
import { Table } from "./constants";

@Injectable({
  providedIn: "root"
})
export class IndexedDBService {
  constructor(private dbService: NgxIndexedDBService, public globalFunction: GlobalFunction) {}

  createOrUpdate(table: Table, data): Observable<any> {
    return this.dbService.getByKey(table, data.id).pipe(
      switchMap((resultgetByKey: any) => {
        const old = resultgetByKey ? { ...resultgetByKey } : {};
        if (this.globalFunction.differentFields(old, data)) {
          const updatedData = { ...old, ...data };
          return this.dbService.update(table, updatedData).pipe(map(() => updatedData));
        }
        // Retornar directamente el objeto viejo si no hay cambios
        return of(old);
      })
    );
  }

  /* Funcion para verificar propiedades que cambiaron */
  verifyUpdated(type: Table, array?) {
    try {
      /* Obtenemos lo valores almacenados */
      this.dbService.getAll(type).subscribe((db) => {
        if (db.length > 0) {
          array.forEach((value_array: any) => {
            const exist = db.find((value_db: any) => value_db.id === value_array.id);
            if (exist) {
              /* Validamos los registros que son diferentes y editamos */
              if (!this.globalFunction.differentFields(exist, value_array)) {
                this.createOrUpdate(type, exist).subscribe((item) => {});
              }
            }
          });
        } else {
          this.bulkAdd(type, array).subscribe((resp) => {});
        }
      });
    } catch (error) {}
  }

  bulkAdd(table: Table, value) {
    return this.dbService.bulkAdd(table, value);
  }

  /**
   * Guarda la lista de estanques de una granja como copia para mostrarla al instante en la
   * siguiente visita. Reemplaza todo lo guardado: solo se conserva la ultima granja y orden,
   * asi nunca se mezclan estanques de otra granja ni quedan estanques eliminados.
   * @param table Tabla donde se guarda.
   * @param farmId Granja de la lista.
   * @param ordering Orden con el que se pidio la lista.
   * @param items Lista tal como la regreso el servidor.
   * @returns void
   */
  saveFarmList(table: Table, farmId: number | string, ordering: string, items: any[]): void {
    const rows = items.map((item, index) => ({
      ...item,
      cache_farm_id: Number(farmId),
      cache_ordering: ordering,
      cache_index: index
    }));
    this.cleardb(table)
      .pipe(concatMap(() => (rows.length > 0 ? this.bulkAdd(table, rows) : of(null))))
      .subscribe({ error: () => {} });
  }

  /**
   * Lee la copia guardada con `saveFarmList` si corresponde a la misma granja y orden.
   * @param table Tabla donde se guardo.
   * @param farmId Granja que se necesita.
   * @param ordering Orden que se necesita.
   * @returns Lista en el orden original (vacia si no hay copia valida).
   */
  getFarmList(table: Table, farmId: number | string, ordering: string): Observable<any[]> {
    return this.dbService.getAll(table).pipe(
      map((rows: any[]) =>
        rows
          .filter(
            (row) => row.cache_farm_id === Number(farmId) && row.cache_ordering === ordering
          )
          .sort((a, b) => a.cache_index - b.cache_index)
      )
    );
  }

  getAllByName(table: Table): Observable<any[]> {
    return this.dbService.getAll(table);
  }

  cleardb(table: Table): Observable<any> {
    return this.dbService.clear(table);
  }

  clearAlldb = async () => {
    const clear_pond = this.cleardb("ponds");
    const clear_ponds_simple = this.cleardb("ponds_simple");

    forkJoin([clear_pond, clear_ponds_simple]).subscribe(
      ([response1]) => {
        // Maneja las respuestas aquí
      },
      (error) => {
        // Maneja errores aquí
      }
    );
  };
  getById(table: Table, id: number) {
    return this.dbService.getByKey(table, id);
  }
  getByIndex(table: Table, index: string, value: string) {
    return this.dbService.getByIndex(table, index, value);
  }
}
